import * as internalAlertTypes from "./alertTypes";
//import {capitalizeFirstLetter} from '../../../utils/helperFunctions'
const internalAlertInitialState = {
  internalAlertRules: {
    alertTypes: {
      Amount: [],
      Text: [],
      Matching: [],
      Gpi: [],
    },
    currentCriterial: null,
    messageTypes: null,
    messageFields: [],
    Templates: {
      Amount: [],
      Text: [],
      Matching: [],
      Gpi: [],
    },
    Currency: null,
    FilterMessages: {
      Amount: [],
      Text: [],
      Matching: [],
      Gpi: [],
    },
  },
};

export const internalAlertReducer = (
  state = internalAlertInitialState,
  action
) => {
  const { type, payload } = action;

  switch (type) {
    case "RESET_FIELDS":
      return {
        ...state,
        messageFields: [],
      };
    case internalAlertTypes.GET_Fields:
      return {
        ...state,
        messageFields: payload,
      };

    case "addnew":
      let obj = {
        alertType: payload,
        name: "",
        currency: null,
        id: -1,
        messageType: "",
        direction: null,
        messageField: "",
        operator: "",
        value: "",
        notificationType: "",
        timeOfDay: null,
        templateId: null,
        receivers: [],
        ccReceivers: [],
      };
      return {
        ...state,
        currentCriterial: obj,
      };

    case internalAlertTypes.LOAD_ALERTS:
      return {
        ...state,
        loadingAlerts: true,
      };

    case internalAlertTypes.STOP_LOAD_ALERTS:
      return {
        ...state,
        loadingAlerts: false,
      };

    case internalAlertTypes.Filter_Messages:
      let Amount =
        payload.id === "All"
          ? state.FilterMessages.Amount
          : state.FilterMessages.Amount.filter(
              (mT) => mT.messageType.id === payload.id
            );
      let Text =
        payload.id === "All"
          ? state.FilterMessages.Text
          : state.FilterMessages.Text.filter(
              (mT) => mT.messageType.id === payload.id
            );
      /*   let Matching = state.alertTypes.Matching.filter((mT) => mT.messageType.id === payload.id)
      let Gpi = state.alertTypes.Gpi.filter((mT) => mT.messageType.id === payload.id) */
      return {
        ...state,
        alertTypes: {
          ...state.alertTypes,
          Amount: Amount,
          Text: Text,
        },
      };

    case internalAlertTypes.CREATE_CRI:
      return {
        ...state,
        currentCriterial: payload,
      };

    case internalAlertTypes.TEMPLATES: {
      let AlertTemplates = payload.filter((temp) => temp.type === "ALERT");
      let AmountTemplates = AlertTemplates.filter(
        (temp) => temp.alertType === "AMOUNT"
      );
      let TextTemplates = AlertTemplates.filter(
        (temp) => temp.alertType === "TEXT"
      );
      let MatchingTemplates = AlertTemplates.filter(
        (temp) => temp.alertType === "MATCHING"
      );
      let GpiTemplates = AlertTemplates.filter(
        (temp) => temp.alertType === "GPI"
      );
      return {
        ...state,
        Templates: {
          Amount: AmountTemplates,
          Text: TextTemplates,
          MatchingTemplates: MatchingTemplates,
          Gpi: GpiTemplates,
        },
      };
    }

    case internalAlertTypes.CURRENCY: {
      return {
        ...state,
        Currency: payload,
      };
    }
    case internalAlertTypes.GET_ALERTS:
      let amount = payload.filter((amount) => amount.alertType === "AMOUNT");
      let text = payload.filter((text) => text.alertType === "TEXT");
      let matching = payload.filter(
        (matching) => matching.alertType === "MATCHING"
      );
      let gpi = payload.filter((gpi) => gpi.alertType === "GPI");
      return {
        ...state,
        alertTypes: {
          ...state.alertTypes,
          Amount: amount,
          Text: text,
        },
        FilterMessages: {
          ...state.FilterMessages,
          Amount: amount,
          Text: text,
        },
        loadingAlerts: false,
      };

    case internalAlertTypes.CURRENT_CRITERIA:
      return {
        ...state,
        currentCriterial: payload,
      };

    case internalAlertTypes.DELETE_CRI:
      /*   let type = payload.alertType.toLowerCase()
             //let finalAlertType = capitalizeFirstLetter(type)
              //let filterdCri = state.alertTypes[finalAlertType].filter((cri) => cri.id !== payload.id)
              console.log("D")
              if (state.alertTypes.hasOwnProperty(finalAlertType)) {
                
                console.log("the key exists on the object"); 
              }
              */
      return {
        ...state,
        alertTypes: {
          ...state.alertTypes,
        },
        currentCriterial: null,
      };
    case internalAlertTypes.MESSAGE_TYPE:
      return {
        ...state,
        messageTypes: payload,
      };

    case internalAlertTypes.RESET_ALERTS:
      return internalAlertInitialState;

    default:
      return { ...state };
  }
};

const FollowingOnInternalAlerts = {
  processing: false,
  rows: [],
  pageSize: 10,
  pageNumber: 1,
  totalItems: 0,
  totalPages: 0,
  updatedAt: new Date(),
  countries: {
    items: [],
  },
  currencies: {
    items: [],
  },
};

export const FollowingOnInternalAlertsReducer = (
  state = FollowingOnInternalAlerts,
  action
) => {
  const { type, payload } = action;

  switch (type) {
    case internalAlertTypes.RESET_INTERNAL_ALERTS:
      return FollowingOnInternalAlerts;
    case internalAlertTypes.SET_PROCESSING_INTERNAL_ALERTS:
      return { ...state, processing: true };
    case internalAlertTypes.STOP_PROCESSING_INTERNAL_ALERTS:
      return { ...state, processing: false };
    case internalAlertTypes.SEARCH_INTERNAL_ALERTS:
      return payload
        ? {
            ...state,
            rows: [...payload.returnResult],
            totalItems: payload.totalItems,
            totalPages: payload.totalPages,
            pageNumber: payload.pageNumber,
            pageSize: payload.pageSize,
            updatedAt: new Date(),
            processing: false,
          }
        : { ...state, processing: false };

    default:
      return state;
  }
};

const FollowingOnInternalNotification = {
  processing: false,
  rows: [],
  pageSize: 10,
  pageNumber: 1,
  totalItems: 0,
  totalPages: 0,
  updatedAt: new Date(),
};

export const FollowingOnInternalNotificationReducer = (
  state = FollowingOnInternalNotification,
  action
) => {
  const { type, payload } = action;

  switch (type) {
    case internalAlertTypes.RESET_INTERNAL_NOTIFICATOIN:
      return FollowingOnInternalNotification;
    case internalAlertTypes.SET_PROCESSING_INTERNAL_NOTIFICATOIN:
      return { ...state, processing: true };
    case internalAlertTypes.STOP_PROCESSING_INTERNAL_NOTIFICATOIN:
      return { ...state, processing: false };
    case internalAlertTypes.SEARCH_INTERNAL_NOTIFICATOIN:
      return payload
        ? {
            ...state,
            rows: [...payload.returnResult],
            totalItems: payload.totalItems,
            totalPages: payload.totalPages,
            pageNumber: payload.pageNumber,
            pageSize: payload.pageSize,
            updatedAt: new Date(),
            processing: false,
          }
        : { ...state, processing: false };

    default:
      return state;
  }
};

const customerList = {
  processing: false,
  messageTypes: [],
  selectedUser: {},
  NotificationTemplates: [],
  Groups: [],
  rows: [],
  FilterRows: [],
  pageSize: 10,
  pageNumber: 1,
  totalItems: 0,
  totalPages: 0,
  updatedAt: new Date(),
  configData: null,
};

export const CustomerList = (state = customerList, action) => {
  const { type, payload } = action;

  switch (type) {
    case "FilterCustomers": {
      let FilterRows = state.rows.filter((row) => row.status === payload.id);
      return {
        ...state,
        rows: payload.id === "All" ? state.FilterRows : FilterRows,
      };
    }

    case internalAlertTypes.GET_CONFIGURATION: {
      return {
        ...state,
        configData: payload,
      };
    }
    case internalAlertTypes.SELECTED_USER: {
      return payload
        ? {
            ...state,
            selectedUser: payload,
          }
        : {
            ...state,
            selectedUser: "",
          };
    }

    case internalAlertTypes.MESSAGE_TYPE:
      return {
        ...state,
        messageTypes: payload,
      };

    case internalAlertTypes.GROUPS:
      return {
        ...state,
        Groups: payload,
      };
    case internalAlertTypes.TEMPLATES:
      let notificationTemplate = payload.filter(
        (temp) => temp.type === "NOTIFICATION"
      );
      return {
        ...state,
        NotificationTemplates: notificationTemplate,
      };
    case internalAlertTypes.RESET_CUSTOMER_LIST:
      return customerList;
    case internalAlertTypes.SET_PROCESSING_CUSTOMER_LIST:
      return { ...state, processing: true };
    case internalAlertTypes.STOP_PROCESSING_CUSTOMER_LIST:
      return { ...state, processing: false };
    case internalAlertTypes.SEARCH_CUSTOMER_LIST:
      return payload
        ? {
            ...state,
            rows: [...payload.returnResult],
            FilterRows: [...payload.returnResult],
            totalItems: payload.totalItems,
            totalPages: payload.totalPages,
            pageNumber: payload.pageNumber,
            pageSize: payload.pageSize,
            updatedAt: new Date(),
            processing: false,
          }
        : { ...state, processing: false };

    default:
      return state;
  }
};

const customersGroups = {
  processing: false,
  SelectedGroup: null,
  GroupList: [],
  AllGroups: [],
  AllCustomers: [],
  loadingGroups: [],
  messageTypes: [],
  NotificationTemplates: [],
  rows: [],
  FilterCustomers: [],
  pageSize: 10,
  pageNumber: 1,
  totalItems: 0,
  totalPages: 0,
  updatedAt: new Date(),
};

export const CustomersGroups = (state = customersGroups, action) => {
  const { type, payload } = action;

  switch (type) {
    case internalAlertTypes.SET_PROCESSING_SUBSCRIBERS_GROUP:
      return { ...state, processing: true };
    case internalAlertTypes.DELETE_GROUP:
      return {
        ...state,
        SelectedGroup: null,
      };
    case internalAlertTypes.RESET_GROUPS:
      return customersGroups;
    case internalAlertTypes.LOAD_NOTIFICATION:
      return {
        ...state,
        loadingGroups: true,
      };
    case internalAlertTypes.All_GROUPS:
      return {
        ...state,
        AllGroups: payload,
        loadingGroups: false,
      };
    case "ADD_GROUP":
      let obj = {
        name: "",
        id: "",
        MT: [
          {
            messageNumber: null,
            sendingType: "",
            direction: "",
            notificationTemplate: "",
          },
        ],
      };
      return payload
        ? {
            ...state,
            SelectedGroup: payload,
          }
        : {
            ...state,
            SelectedGroup: obj,
            rows: [],
          };

    case internalAlertTypes.MESSAGE_TYPE:
      return {
        ...state,
        messageTypes: payload,
      };
    case internalAlertTypes.TEMPLATES:
      let notificationTemplate = payload.filter(
        (temp) => temp.type === "NOTIFICATION"
      );
      return {
        ...state,
        NotificationTemplates: notificationTemplate,
      };
    case internalAlertTypes.CUSTOMERS_LIST:
      let customersActive = [
        ...payload.returnResult.filter(
          (customer) => customer.status === "ACTIVE"
        ),
      ];
      return {
        ...state,
        AllCustomers: customersActive,
        FilterCustomers: customersActive,
      };
    case internalAlertTypes.RESET_CUSTOMER_GROUPS:
      return customersGroups;
    case internalAlertTypes.CUSTOMERS_IN_GROUP:
      return payload
        ? {
            ...state,

            rows: [...payload.returnResult],
            totalItems: payload.totalItems,
            totalPages: payload.totalPages,
            pageNumber: payload.pageNumber,
            pageSize: payload.pageSize,
            updatedAt: new Date(),
            processing: false,
          }
        : { ...state, processing: false };

    default:
      return state;
  }
};
